import { fabric } from 'fabric';
import React from 'react';
import ShapeBase from '../shapes/ShapeBase';
import AnalyticsBehaviors from './AnalyticsBehaviors';
import CollaborationBehaviors from './CollaborationBehaviors';
import EmbeddedBookmarkContainer from './EmbeddedBookmarkContainer';
import ReadOnlyBehaviors from './ReadOnlyBehaviors';
import SmartGuideBehaviors from './SmartGuideBehaviors';
import ExternalContentBehaviors from '../objects/ExternalContentBehaviors';
import LockBehaviors from './LockBehaviors';
import CommentableBehaviors from './CommentableBehaviors';
import tools from '../tools';
import '../interactiveOverlayContainer.css';
import trackEvent from '../utils/analytics';
import FrameMemberBehaviors from './FrameMemberBehaviors';
import LinearResizeControl from '../controls/LinearResizeControl';

const PLACEHOLDER_WIDTH = 37;
const PLACEHOLDER_HEIGHT = 29;
const PLACEHOLDER_RATIO = PLACEHOLDER_WIDTH / PLACEHOLDER_HEIGHT;

const EMBEDDEDBOOKMARK_PLACEHOLDER = `<svg width="37" height="29" viewBox="0 0 37 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4617_32163)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.5C0 2.61438 0 1.67157 0.585786 1.08579C1.17157 0.5 2.11438 0.5 4 0.5H33C34.8856 0.5 35.8284 0.5 36.4142 1.08579C37 1.67157 37 2.61438 37 4.5V24.5C37 26.3856 37 27.3284 36.4142 27.9142C35.8284 28.5 34.8856 28.5 33 28.5H4C2.11438 28.5 1.17157 28.5 0.585786 27.9142C0 27.3284 0 26.3856 0 24.5V4.5ZM16.6068 1.9H33C33.9824 1.9 34.5783 1.90297 35.008 1.96074C35.2064 1.98741 35.3121 2.01962 35.3661 2.04184C35.4075 2.05885 35.418 2.0694 35.4237 2.07514L35.4249 2.07633C35.4306 2.08203 35.4412 2.09253 35.4582 2.13388C35.4804 2.18789 35.5126 2.29361 35.5393 2.492C35.597 2.92166 35.6 3.51761 35.6 4.5V6.63184H31.0822L29.0489 4.59856L27.0156 6.63184H14.7953V3.71152L16.6068 1.9ZM12.3834 1.9H4C3.01761 1.9 2.42166 1.90297 1.992 1.96074C1.79361 1.98741 1.68789 2.01962 1.63388 2.04184C1.59252 2.05885 1.58203 2.06941 1.57633 2.07514L1.57514 2.07633C1.56941 2.08203 1.55885 2.09252 1.54184 2.13388C1.51962 2.18789 1.48741 2.29361 1.46074 2.492C1.40297 2.92166 1.4 3.51761 1.4 4.5V6.63184H14.1953V3.71191L12.3834 1.9ZM1.4 7.33184V17.6536H14.1953V13.3976L12.6372 13.3976C12.559 13.3976 12.5198 13.3976 12.4824 13.4074C12.4449 13.4172 12.4108 13.4365 12.3426 13.4749L10.7051 14.3976C10.3069 14.622 10.1078 14.7342 9.95919 14.6473C9.81055 14.5605 9.81055 14.332 9.81055 13.8749V12.1762C9.81055 11.8933 9.81055 11.7519 9.89842 11.664C9.98629 11.5762 10.1277 11.5762 10.4106 11.5762L14.1953 11.5762V7.33184L1.4 7.33184ZM1.4 18.3536V24.5C1.4 25.4824 1.40297 26.0783 1.46074 26.508C1.48741 26.7064 1.51962 26.8121 1.54184 26.8661C1.55885 26.9075 1.56941 26.918 1.57514 26.9237L1.57633 26.9249C1.58203 26.9306 1.59252 26.9411 1.63388 26.9582C1.68789 26.9804 1.79361 27.0126 1.992 27.0393C2.42166 27.097 3.01761 27.1 4 27.1H14.1953V23.292L8.90202 23.2934C8.78728 23.2934 8.72991 23.2934 8.67766 23.3137C8.62542 23.3339 8.58301 23.3725 8.49818 23.4498L7.89268 24.0012C7.46169 24.3938 7.24619 24.59 7.06743 24.5111C6.88867 24.4321 6.88867 24.1406 6.88867 23.5576V21.9289C6.88867 21.6461 6.88867 21.5047 6.97652 21.4168C7.06437 21.329 7.20577 21.329 7.48857 21.3289L14.1953 21.3277V18.3536H1.4ZM14.7953 27.1H33C33.9824 27.1 34.5783 27.097 35.008 27.0393C35.2064 27.0126 35.3121 26.9804 35.3661 26.9582C35.4075 26.9411 35.418 26.9306 35.4237 26.9249L35.4249 26.9237C35.4306 26.918 35.4412 26.9075 35.4582 26.8661C35.4804 26.8121 35.5126 26.7064 35.5393 26.508C35.597 26.0783 35.6 25.4824 35.6 24.5V18.3536H14.7953V21.3276L17.0141 21.3273C17.297 21.3272 17.4384 21.3272 17.5263 21.4151C17.6142 21.5029 17.6142 21.6444 17.6142 21.9273V23.524C17.6142 24.1188 17.6142 24.4161 17.4331 24.4943C17.252 24.5725 17.0356 24.3686 16.6027 23.9607L16.066 23.455C15.9804 23.3743 15.9376 23.3339 15.8842 23.3128C15.8309 23.2916 15.7721 23.2916 15.6544 23.2916L14.7953 23.2919V27.1ZM35.6 17.6536V7.33184H30.8822L29.0489 9.16511L27.2156 7.33184L14.7953 7.33184V11.5762L30.25 11.5764C30.5328 11.5764 30.6742 11.5764 30.7621 11.6642C30.85 11.7521 30.85 11.8935 30.85 12.1764V13.8644C30.85 14.3256 30.85 14.5562 30.7002 14.6429C30.5504 14.7295 30.3505 14.6145 29.9507 14.3845L28.3749 13.4777C28.3058 13.438 28.2713 13.4181 28.2333 13.408C28.1952 13.3978 28.1554 13.3978 28.0757 13.3978L14.7953 13.3976V17.6536H35.6Z" fill="#B5B5B5"/>
</g>
<defs>
<clipPath id="clip0_4617_32163">
<rect width="37" height="28" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
`;

interface EmbeddedBookmark
  extends fabric.Object,
    ReadOnlyBehaviors,
    SmartGuideBehaviors,
    CollaborationBehaviors,
    LockBehaviors,
    CommentableBehaviors,
    FrameMemberBehaviors {}

@AnalyticsBehaviors
@ReadOnlyBehaviors
@ExternalContentBehaviors
@SmartGuideBehaviors
@CollaborationBehaviors
@LockBehaviors
@CommentableBehaviors
@FrameMemberBehaviors
class EmbeddedBookmark extends fabric.Object {
  type = 'embeddedBookmark';

  uniformScaling = true;
  minScaleLimit = 0.05;

  bookmarkId: string;

  bookmarkLoaded = false;
  showInteractLayer: boolean;

  serializedKeys = [
    'z',
    'textContent',
    'left',
    'top',
    'width',
    'height',
    'scaleX',
    'scaleY',
    'opacity',
    'bookmarkId',
  ];

  controls = {
    tl: ShapeBase.resizeControl({ x: -0.5, y: -0.5 }),
    tr: ShapeBase.resizeControl({ x: 0.5, y: -0.5 }),
    bl: ShapeBase.resizeControl({ x: -0.5, y: 0.5 }),
    br: ShapeBase.resizeControl({ x: 0.5, y: 0.5 }),
    mt: new LinearResizeControl({ edge: 'top' }),
    mb: new LinearResizeControl({ edge: 'bottom' }),
    ml: new LinearResizeControl({ edge: 'left' }),
    mr: new LinearResizeControl({ edge: 'right' }),
  };

  static placeholderImage: HTMLImageElement | null = null;

  constructor(options) {
    options.width ||= EmbeddedBookmark.defaultWidth();
    options.height ||= EmbeddedBookmark.defaultHeight();
    super(options);

    this.initializeLockBehaviors(options.locked);
    this.initializeSmartGuides();
    this.initializeFrameMember();

    this.on('mousedblclick', this.beginIFrameViewing);

    ['deselected', 'moving', 'rotating', 'scaling'].forEach(event =>
      this.on(event, this.endIFrameViewing)
    );

    this.on('selected', () => this.setShowInteractLayer(true));
    this.on('mousemove', () => this.setShowInteractLayer(true));
    this.on('mouseover', () => this.setShowInteractLayer(true));
    this.on('mouseout', () => this.setShowInteractLayer(false));

    EmbeddedBookmark._preparePlaceholder();
  }

  static _preparePlaceholder() {
    if (EmbeddedBookmark.placeholderImage) return;
    EmbeddedBookmark.placeholderImage = new Image();
    EmbeddedBookmark.placeholderImage.src =
      EmbeddedBookmark.encodedPlaceholder();
    EmbeddedBookmark.placeholderImage.decode();
  }

  static encodedPlaceholder() {
    // Encode the svg as a data url for use in html img tags
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
      EMBEDDEDBOOKMARK_PLACEHOLDER
    )}`;
  }

  tools() {
    return [tools.ToolOpenView];
  }

  beginIFrameViewing = () => {
    if (this.canDisplayBookmark && this.bookmarkLoaded) {
      this.setShowInteractLayer(false);
      this.canvas.externalContent.focus(this);
      this.controller.actionShowEmbeddedBookmarkExitButton(true);
      trackEvent(
        'Feature-7226844293821880091',
        'User interacts with whiteboard view'
      );
    }
  };

  endIFrameViewing = () => {
    this.canvas.externalContent.blur();
    this.controller.actionShowEmbeddedBookmarkExitButton(false);
  };

  hasExternalContent() {
    return true;
  }

  clipExternalContent() {
    return !this.canvas.exporting;
  }

  minDimension({ resizingWidth = true }) {
    return resizingWidth
      ? EmbeddedBookmark.defaultWidth()
      : EmbeddedBookmark.defaultHeight();
  }

  maxDimension() {
    return Number.MAX_SAFE_INTEGER;
  }

  static defaultWidth() {
    return 300;
  }

  static defaultHeight() {
    return 200;
  }

  get publishUrl() {
    return `${this.bookmarkUrl}.publish?disable_link_filtering=true`;
  }

  get bookmarkUrl() {
    return `/bookmarks/${this.bookmarkId}`;
  }

  get canDisplayBookmark() {
    return (
      !window.isPublishing &&
      !window.isKnowledgeBase &&
      !this.controller.isShared &&
      !this.canvas?.exporting
    );
  }

  handleIframeClick = ({
    url,
    newTab,
    useBottomDrawer,
  }: {
    url: string;
    newTab?: boolean;
    useBottomDrawer?: boolean;
  }) => {
    if (url) {
      this.handleLinkClick({ url, newTab, useBottomDrawer });
    } else {
      this.controller.closeAhaDrawer();
    }
  };

  handleLinkClick = ({
    url,
    newTab,
    useBottomDrawer,
  }: {
    url: string;
    newTab?: boolean;
    useBottomDrawer?: boolean;
  }) => {
    if (url && newTab) {
      window.open(url, '_blank', 'noopener noreferrer');
    } else if (url && this.controller.allowRecordLinking()) {
      this.controller.props.openAhaDrawer!({ url, useBottomDrawer });
    }
  };

  setShowInteractLayer(show: boolean) {
    const currentShowInteractiveLayer = this.showInteractLayer;
    this.showInteractLayer = this.bookmarkLoaded && this.isSelected() && show;
    // Render the bookmark again in order to update the interactive layer component
    if (currentShowInteractiveLayer !== this.showInteractLayer) {
      this.canvas?.externalContent?.render(this);
    }
  }

  _renderPlaceholder(ctx, obj) {
    // Render background for placeholder image
    ctx.save();
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#cccccc';
    ctx.strokeRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);
    ctx.fillStyle = '#f9f9f9';
    ctx.fillRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);
    ctx.restore();

    // Size the placeholder image
    const width = obj.getScaledWidth();
    const height = obj.getScaledHeight();
    const imageSize = Math.min(width, height) * 0.4;
    // Maintain the image ratio based on the dimensions of the custom
    // EMBEDDEDBOOKMARK_PLACEHOLDER svg.
    const imageWidth = imageSize * PLACEHOLDER_RATIO;
    const imageHeight = imageSize;
    ctx.drawImage(
      EmbeddedBookmark.placeholderImage,
      -imageWidth / 2,
      -imageHeight / 2,
      imageWidth,
      imageHeight
    );
  }

  _render(ctx: CanvasRenderingContext2D) {
    if (this.canvas.exporting) {
      this._renderPlaceholder(ctx, this);
    }
  }

  renderExternalContent() {
    const {
      scaleX = 1,
      scaleY = 1,
      width = EmbeddedBookmark.defaultWidth(),
      height = EmbeddedBookmark.defaultHeight(),
      showInteractLayer,
      canDisplayBookmark,
    } = this;

    // This provides some reasonable limits to the size of the interactive overlay
    // as the bookmark scales. This could likely be done with css min/max and
    // percentages when those are supported
    const gap = Math.max(4, 12 * scaleX);
    const bottom = Math.min(20, 20 * scaleY);
    const padding = Math.max(4, 20 * scaleX);
    const fontSize = Math.max(4, 14 * scaleX);

    return (
      <div>
        <EmbeddedBookmarkContainer
          url={this.publishUrl}
          width={width}
          height={height}
          scale={scaleX}
          placeholder={EmbeddedBookmark.encodedPlaceholder()}
          showPlaceholder={!canDisplayBookmark}
          exporting={this.canvas.exporting}
          onClick={this.handleIframeClick}
          onLoaded={() => (this.bookmarkLoaded = true)}
        />
        {canDisplayBookmark && showInteractLayer && (
          <div className='interactive-overlay-container' style={{ bottom }}>
            <div
              className='interactive-overlay-container__content'
              style={{ gap, padding, fontSize }}
            >
              <i className='fas fa-bullseye-pointer'></i>
              Double click to interact with the view
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default EmbeddedBookmark;
